import { z } from 'zod';
import '@apexdesigner/schema-tools';
import { hasMany, hasOne } from '@apexdesigner/schema-tools';

export const user = z
  .object({
    id: z.number().hidden().describe('Unique identifier'),

    email: z.string().describe('Email - User email address'),

    roleAssignments: hasMany('RoleAssignment'),

    activityPeriods: hasMany('UserActivityPeriod'),

    tutor: hasOne('Tutor', 'appUserId'),

    customerAccountManagerTerms: hasMany('Term', 'customerAccountManagerId'),

    literacyManagerTerms: hasMany('Term', 'literacyManagerId'),

    siteLeaderTerms: hasMany('Term', 'siteLeaderId'),

    student: hasOne('Student', 'appUserId'),

    createdResources: hasMany('Resource', 'createdById'),

    publishedResources: hasMany('Resource', 'publishedById'),

    archivedResources: hasMany('Resource', 'archivedById'),

    createdResourceSets: hasMany('ResourceSet', 'createdById'),

    publishedResourceSets: hasMany('ResourceSet', 'publishedById'),

    archivedResourceSets: hasMany('ResourceSet', 'archivedById'),

    testResults: hasMany('TestResult', 'appUserId'),

    createdCurriculums: hasMany('Curriculum', 'createdById'),

    publishedCurriculums: hasMany('Curriculum', 'publishedById'),

    archivedCurriculums: hasMany('Curriculum', 'archivedById'),
  })
  .describe('Authenticated user identified by email address.')
  .as('User');

export { user as userSchema };
